/* Progressive enhancement only. Shopify creates and authenticates the customer. */
(() => {
  'use strict';
  const menus = () => document.querySelectorAll('[data-member-menu][open]');
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest('[data-member-menu]')) menus().forEach(menu => menu.removeAttribute('open'));
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    menus().forEach(menu => { menu.removeAttribute('open'); menu.querySelector('summary')?.focus(); });
  });
  function initialize(root = document) {
    const recover = root.querySelector('#recover');
    if (recover && (window.location.hash === '#recover' || recover.querySelector('.form-success, .form-errors'))) recover.open = true;
    root.querySelectorAll('[data-country-selector]').forEach(country => {
      if (country.dataset.bound) return;
      country.dataset.bound = '1';
      const province = document.getElementById(country.dataset.provinceId);
      if (!province) return;
      const selectValue = (select, value) => {
        const option = Array.from(select.options).find(o => o.value === value || o.textContent === value);
        if (option) select.value = option.value;
      };
      selectValue(country, country.dataset.default || '');
      const update = () => {
        let list = [];
        try { list = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]'); } catch (_) { list = []; }
        province.replaceChildren();
        if (!Array.isArray(list)) list = [];
        list.forEach(pair => { if (Array.isArray(pair) && pair.length >= 2) province.add(new Option(String(pair[1]), String(pair[0]))); });
        const wrapper = province.closest('[data-province-container]');
        if (wrapper) wrapper.hidden = list.length === 0;
        province.disabled = list.length === 0;
        selectValue(province, province.dataset.default || '');
      };
      country.addEventListener('change', update); update();
    });
  }
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  // Re-fetch server-rendered customer state on browser history restoration; never fake it.
  window.addEventListener('pageshow', event => { if (event.persisted) window.location.reload(); });
  initialize();
})();
